(function () {
    if (window.YumeLandingCargado) return;
    window.YumeLandingCargado = true;
    var MONTO = '{' + '{amount}' + '}';
    var movimientoReducido = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var modoEditor = !!(window.Shopify && window.Shopify.designMode);

    function cada(lista, accion) {
      Array.prototype.forEach.call(lista, accion);
    }

    function formatearDinero(centimos, formato) {
      var valor = Math.round(Number(centimos) || 0);
      var plantilla = formato || MONTO;
      var patron = /\{\{\s*(\w+)\s*\}\}/;
      function separar(numero, decimales, miles, coma) {
        var partes = (numero / 100).toFixed(decimales).split('.');
        var enteros = partes[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + miles);
        return partes[1] ? enteros + coma + partes[1] : enteros;
      }
      var coincidencia = plantilla.match(patron);
      var tipo = coincidencia ? coincidencia[1] : 'amount';
      var texto;
      if (tipo === 'amount_no_decimals') texto = separar(valor, 0, ',', '.');
      else if (tipo === 'amount_with_comma_separator') texto = separar(valor, 2, '.', ',');
      else if (tipo === 'amount_no_decimals_with_comma_separator') texto = separar(valor, 0, '.', ',');
      else if (tipo === 'amount_with_apostrophe_separator') texto = separar(valor, 2, "'", '.');
      else if (tipo === 'amount_with_space_separator') texto = separar(valor, 2, ' ', ',');
      else texto = separar(valor, 2, ',', '.');
      return plantilla.replace(patron, texto);
    }

    function anadirAlCarrito(variante, cantidad, origen) {
      var carrito = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var rutas = window.routes || {};
      var configuracion = typeof window.fetchConfig === 'function'
        ? window.fetchConfig('javascript')
        : { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' } };
      var cuerpo = { items: [{ id: variante, quantity: cantidad }] };
      if (carrito && typeof carrito.getSectionsToRender === 'function') {
        cuerpo.sections = carrito.getSectionsToRender().map(function (seccion) { return seccion.id; });
        cuerpo.sections_url = window.location.pathname;
      }
      configuracion.body = JSON.stringify(cuerpo);
      return fetch(rutas.cart_add_url || '/cart/add', configuracion)
        .then(function (respuesta) { return respuesta.json(); })
        .then(function (estado) {
          if (estado.status) return estado;
          if (!carrito || typeof carrito.renderContents !== 'function') {
            window.location.href = rutas.cart_url || '/cart';
            return estado;
          }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: origen, productVariantId: variante, cartData: estado });
          }
          carrito.renderContents(estado);
          carrito.classList.remove('is-empty');
          var interior = carrito.querySelector('.drawer__inner');
          if (interior) interior.classList.remove('is-empty');
          return estado;
        });
    }

    function iniciar(raiz) {
      if (!raiz || raiz.getAttribute('data-yume-lp-listo') === 'true') return;
      raiz.setAttribute('data-yume-lp-listo', 'true');

      var formato = raiz.getAttribute('data-formato-dinero') || MONTO;
      var estado = {
        variante: raiz.getAttribute('data-variante'),
        precio: Number(raiz.getAttribute('data-precio-base')) || 0,
        anterior: Number(raiz.getAttribute('data-precio-anterior')) || 0,
        disponible: raiz.getAttribute('data-disponible') === 'true'
      };
      var visor = raiz.querySelector('[data-yume-lp-visor]');
      var miniaturas = raiz.querySelectorAll('[data-yume-lp-miniaturas] button');
      var packs = raiz.querySelectorAll('[data-yume-lp-pack]');
      var boton = raiz.querySelector('[data-yume-lp-comprar]');
      var textoBoton = raiz.querySelector('[data-yume-lp-texto-boton]');
      var error = raiz.querySelector('[data-yume-lp-error]');
      var barra = raiz.querySelector('[data-yume-lp-barra]');
      var botonBarra = raiz.querySelector('[data-yume-lp-comprar-barra]');

      function registrar(evento, cantidad, valor) {
        if (raiz.getAttribute('data-tracking') !== 'true') return;
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: evento,
          variant_id: Number(estado.variante),
          quantity: cantidad,
          value: valor / 100,
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR'
        });
      }

      function irAFoto(indice) {
        if (!visor) return;
        var fotos = visor.children;
        if (!fotos[indice]) return;
        visor.scrollTo({ left: fotos[indice].offsetLeft - visor.offsetLeft, behavior: movimientoReducido ? 'auto' : 'smooth' });
      }

      function marcarMiniatura(indice) {
        cada(miniaturas, function (miniatura, posicion) {
          miniatura.classList.toggle('yume-lp-activa', posicion === indice);
        });
      }

      cada(miniaturas, function (miniatura) {
        miniatura.addEventListener('click', function () {
          var indice = Number(miniatura.getAttribute('data-indice')) || 0;
          irAFoto(indice);
          marcarMiniatura(indice);
        });
      });

      if (visor && miniaturas.length) {
        var esperaScroll;
        visor.addEventListener('scroll', function () {
          window.clearTimeout(esperaScroll);
          esperaScroll = window.setTimeout(function () {
            var indice = Math.round(visor.scrollLeft / Math.max(1, visor.clientWidth));
            marcarMiniatura(indice);
          }, 80);
        }, { passive: true });
      }

      var variantesDatos = [];
      var nodoVariantes = raiz.querySelector('[data-yume-lp-variantes-json]');
      if (nodoVariantes) {
        try {
          variantesDatos = JSON.parse(nodoVariantes.textContent) || [];
        } catch (e) {
          variantesDatos = [];
        }
      }
      var posPack = Number(raiz.getAttribute('data-pos-pack')) || 0;
      var ignorarStock = raiz.getAttribute('data-ignorar-stock') === 'true';
      var opcionesActuales = [];
      variantesDatos.forEach(function (dato) {
        if (String(dato.id) === String(estado.variante)) opcionesActuales = dato.opciones.slice();
      });
      if (!opcionesActuales.length && variantesDatos[0]) opcionesActuales = variantesDatos[0].opciones.slice();

      function buscarVariante(opciones) {
        var encontrada = null;
        variantesDatos.forEach(function (dato) {
          if (encontrada || dato.opciones.length !== opciones.length) return;
          var igual = true;
          for (var i = 0; i < opciones.length; i += 1) {
            if (dato.opciones[i] !== opciones[i]) igual = false;
          }
          if (igual) encontrada = dato;
        });
        return encontrada;
      }

      function aplicarVariante() {
        var dato = buscarVariante(opcionesActuales);
        if (!dato) {
          estado.disponible = false;
          return;
        }
        var cambioFoto = String(dato.id) !== String(estado.variante);
        estado.variante = String(dato.id);
        estado.precio = Number(dato.precio) || 0;
        estado.anterior = Number(dato.anterior) || 0;
        estado.disponible = ignorarStock || !!dato.disponible;
        if (cambioFoto && dato.media && visor) {
          cada(visor.children, function (foto, indice) {
            if (foto.getAttribute('data-media-id') === String(dato.media)) {
              irAFoto(indice);
              marcarMiniatura(indice);
            }
          });
        }
      }

      function packActivo() {
        var activo = null;
        cada(packs, function (pack) {
          var radio = pack.querySelector('input');
          if (radio && radio.checked) activo = pack;
        });
        return activo;
      }

      function calcular() {
        var base = estado.anterior > estado.precio ? estado.anterior : estado.precio;
        var activo = packActivo();
        var unidades = activo ? Number(activo.getAttribute('data-unidades')) || 1 : 1;
        return { unidades: unidades, cantidad: 1, pack: activo ? activo.getAttribute('data-valor') : '', base: base, total: estado.precio, unidad: estado.precio };
      }

      function pintar() {
        var activo = packActivo();
        cada(packs, function (pack) {
          pack.classList.toggle('yume-lp-activa', pack === activo);
          if (!posPack) return;
          var opciones = opcionesActuales.slice();
          opciones[posPack - 1] = pack.getAttribute('data-valor');
          var dato = buscarVariante(opciones);
          pack.hidden = !dato;
          if (!dato) return;
          var unidades = Number(pack.getAttribute('data-unidades')) || 1;
          var total = pack.querySelector('[data-total]');
          var base = pack.querySelector('[data-base]');
          var unidad = pack.querySelector('[data-unidad]');
          if (total) total.textContent = formatearDinero(dato.precio, formato);
          if (base) {
            base.hidden = !(dato.anterior > dato.precio);
            base.textContent = formatearDinero(dato.anterior, formato);
          }
          if (unidad) unidad.textContent = formatearDinero(Math.floor(dato.precio / unidades), formato) + (raiz.getAttribute('data-texto-unidad') || '');
        });

        actualizarChipsAhorro();
        actualizarInversion(false);
        actualizarOferta();
        var hayOferta = estado.anterior > estado.precio;
        cada(raiz.querySelectorAll('[data-yume-lp-precio]'), function (elemento) {
          elemento.textContent = formatearDinero(estado.precio, formato);
        });
        cada(raiz.querySelectorAll('[data-yume-lp-anterior]'), function (elemento) {
          elemento.hidden = !hayOferta;
          if (hayOferta) elemento.textContent = formatearDinero(estado.anterior, formato);
        });
        var chip = raiz.querySelector('[data-yume-lp-chip]');
        if (chip) {
          chip.hidden = !hayOferta;
          if (hayOferta) {
            var porcentaje = Math.floor(((estado.anterior - estado.precio) * 100) / estado.anterior) + '%';
            chip.textContent = (chip.getAttribute('data-plantilla') || '').replace('[[valor]]', porcentaje);
          }
        }

        if (!boton || !textoBoton) return;
        if (!estado.disponible) {
          boton.disabled = true;
          textoBoton.textContent = raiz.getAttribute('data-texto-agotado') || '';
          if (botonBarra) botonBarra.disabled = true;
          return;
        }
        boton.disabled = false;
        if (botonBarra) botonBarra.disabled = false;
        textoBoton.textContent = (raiz.getAttribute('data-texto-boton') || '').replace('[[precio]]', formatearDinero(estado.precio, formato));
      }

      cada(packs, function (pack) {
        var radio = pack.querySelector('input');
        if (!radio) return;
        radio.addEventListener('change', function () {
          var precioAntes = estado.precio;
          celebrarOferta = true;
          if (posPack) opcionesActuales[posPack - 1] = pack.getAttribute('data-valor');
          aplicarVariante();
          pintar();
          efectoPack(pack, precioAntes);
          if (modal && !modal.hidden) pintarFormulario();
          registrar('yume_select_pack', 1, estado.precio);
        });
      });

      var botonesOpcion = raiz.querySelectorAll('[data-yume-lp-opcion]');
      cada(botonesOpcion, function (botonOpcion) {
        botonOpcion.addEventListener('click', function () {
          var posicion = Number(botonOpcion.getAttribute('data-pos')) || 0;
          cada(botonesOpcion, function (otro) {
            if (otro.getAttribute('data-pos') !== botonOpcion.getAttribute('data-pos')) return;
            var activo = otro === botonOpcion;
            otro.classList.toggle('yume-lp-activa', activo);
            otro.setAttribute('aria-checked', activo ? 'true' : 'false');
          });
          opcionesActuales[posicion] = botonOpcion.getAttribute('data-valor');
          aplicarVariante();
          pintar();
          if (modal && !modal.hidden) pintarFormulario();
        });
      });

      var modal = raiz.querySelector('[data-yume-lp-modal]');
      var PROVINCIAS = [
        ['01', 'VI', 'Álava'], ['02', 'AB', 'Albacete'], ['03', 'A', 'Alicante'], ['04', 'AL', 'Almería'], ['33', 'O', 'Asturias'],
        ['05', 'AV', 'Ávila'], ['06', 'BA', 'Badajoz'], ['07', 'PM', 'Baleares'], ['08', 'B', 'Barcelona'], ['48', 'BI', 'Bizkaia'],
        ['09', 'BU', 'Burgos'], ['10', 'CC', 'Cáceres'], ['11', 'CA', 'Cádiz'], ['39', 'S', 'Cantabria'], ['12', 'CS', 'Castellón'],
        ['51', 'CE', 'Ceuta'], ['13', 'CR', 'Ciudad Real'], ['14', 'CO', 'Córdoba'], ['15', 'C', 'A Coruña'], ['16', 'CU', 'Cuenca'],
        ['20', 'SS', 'Gipuzkoa'], ['17', 'GI', 'Girona'], ['18', 'GR', 'Granada'], ['19', 'GU', 'Guadalajara'], ['21', 'H', 'Huelva'],
        ['22', 'HU', 'Huesca'], ['23', 'J', 'Jaén'], ['26', 'LO', 'La Rioja'], ['35', 'GC', 'Las Palmas'], ['24', 'LE', 'León'],
        ['25', 'L', 'Lleida'], ['27', 'LU', 'Lugo'], ['28', 'M', 'Madrid'], ['29', 'MA', 'Málaga'], ['52', 'ML', 'Melilla'],
        ['30', 'MU', 'Murcia'], ['31', 'NA', 'Navarra'], ['32', 'OR', 'Ourense'], ['34', 'P', 'Palencia'], ['36', 'PO', 'Pontevedra'],
        ['37', 'SA', 'Salamanca'], ['38', 'TF', 'Santa Cruz de Tenerife'], ['40', 'SG', 'Segovia'], ['41', 'SE', 'Sevilla'], ['42', 'SO', 'Soria'],
        ['43', 'T', 'Tarragona'], ['44', 'TE', 'Teruel'], ['45', 'TO', 'Toledo'], ['46', 'V', 'Valencia'], ['47', 'VA', 'Valladolid'],
        ['49', 'ZA', 'Zamora'], ['50', 'Z', 'Zaragoza']
      ];
      var CLAVE_DATOS = 'yume-lp-datos-envio';
      var focoPrevio = null;
      var pagoElegido = 'cod';

      function guardarDatos(datos) {
        try {
          window.sessionStorage.setItem(CLAVE_DATOS, JSON.stringify(datos));
        } catch (e) {
          return;
        }
      }

      function leerDatos() {
        try {
          return JSON.parse(window.sessionStorage.getItem(CLAVE_DATOS) || '{}') || {};
        } catch (e) {
          return {};
        }
      }

      function descuentoTarjeta(total) {
        var valor = Number(raiz.getAttribute('data-form-valor')) || 0;
        if (raiz.getAttribute('data-form-tipo') === 'porcentaje') return Math.floor((total * valor) / 100);
        return Math.min(total, Math.round(valor * 100));
      }

      function pintarFormulario() {
        if (!modal) return;
        var activo = packActivo();
        var datos = calcular(activo);
        var usarAnterior = estado.anterior > estado.precio;
        var subtotal = usarAnterior ? estado.anterior : datos.base;
        var descuento = subtotal - datos.total;
        var filaDescuento = modal.querySelector('[data-yume-lp-fila-descuento]');
        modal.querySelector('[data-yume-lp-subtotal]').textContent = formatearDinero(subtotal, formato);
        modal.querySelector('[data-yume-lp-total]').textContent = formatearDinero(datos.total, formato);
        if (filaDescuento) {
          filaDescuento.hidden = descuento <= 0;
          modal.querySelector('[data-yume-lp-descuento]').textContent = '- ' + formatearDinero(descuento, formato);
        }
        modal.querySelector('[data-yume-lp-resumen-uds]').textContent = '×' + datos.unidades;
        var detalle = modal.querySelector('[data-yume-lp-resumen-detalle]');
        if (detalle) {
          var regalosResumen = regalosIncluidos();
          detalle.textContent = opcionesActuales.join(' · ') + (regalosResumen.length ? ' · 🎁 ' + regalosResumen.join(', ') : '');
        }
        var textoCod = modal.querySelector('[data-yume-lp-texto-cod]');
        if (textoCod) textoCod.textContent = (raiz.getAttribute('data-form-texto-cod') || '').replace('[[precio]]', formatearDinero(datos.total, formato));
        var rebaja = descuentoTarjeta(datos.total);
        var textoTarjeta = modal.querySelector('[data-yume-lp-texto-tarjeta]');
        if (textoTarjeta) textoTarjeta.textContent = (raiz.getAttribute('data-form-texto-tarjeta') || '').replace('[[precio]]', formatearDinero(datos.total - rebaja, formato));
        var textoAhorro = modal.querySelector('[data-yume-lp-texto-ahorro]');
        if (textoAhorro) textoAhorro.textContent = (raiz.getAttribute('data-form-texto-ahorro') || '').replace('[[ahorro]]', formatearDinero(rebaja, formato));
      }

      function campo(nombre) {
        return modal ? modal.querySelector('[name="' + nombre + '"]') : null;
      }

      function limpiar(texto) {
        return String(texto || '').replace(/\s+/g, ' ').trim();
      }

      function telefonoLimpio(texto) {
        var numeros = String(texto || '').replace(/[^\d+]/g, '');
        if (numeros.indexOf('+34') === 0) numeros = numeros.slice(3);
        if (numeros.indexOf('0034') === 0) numeros = numeros.slice(4);
        return numeros.replace(/\D/g, '');
      }

      function validarCampo(nombre) {
        var entrada = campo(nombre);
        if (!entrada) return true;
        var caja = entrada.closest('.yume-lp-campo');
        var error = caja.querySelector('.yume-lp-campo__error');
        var valor = limpiar(entrada.value);
        var ok = true;
        if (nombre === 'nombre') ok = valor.split(' ').length >= 2 && valor.length >= 5;
        else if (nombre === 'telefono') ok = /^[6789]\d{8}$/.test(telefonoLimpio(valor));
        else if (nombre === 'direccion') ok = valor.length >= 5 && /\d/.test(valor);
        else if (nombre === 'cp') ok = /^(0[1-9]|[1-4]\d|5[0-2])\d{3}$/.test(valor);
        else if (nombre === 'provincia') ok = !!valor;
        else if (nombre === 'ciudad') ok = valor.length >= 2;
        else if (nombre === 'email') ok = valor ? /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(valor) : raiz.getAttribute('data-form-email-obligatorio') !== 'true';
        else ok = true;
        caja.classList.toggle('yume-lp-campo--error', !ok);
        caja.classList.toggle('yume-lp-campo--ok', ok && !!valor);
        if (error) {
          error.hidden = ok;
          error.textContent = ok ? '' : error.getAttribute('data-error');
        }
        entrada.setAttribute('aria-invalid', ok ? 'false' : 'true');
        return ok;
      }

      function prepararFormulario() {
        if (!modal || modal.getAttribute('data-listo') === 'true') return;
        modal.setAttribute('data-listo', 'true');
        var selector = modal.querySelector('[data-yume-lp-provincias]');
        if (selector) {
          var vacia = document.createElement('option');
          vacia.value = '';
          vacia.textContent = raiz.getAttribute('data-form-placeholder-provincia') || '';
          selector.appendChild(vacia);
          PROVINCIAS.forEach(function (provincia) {
            var opcion = document.createElement('option');
            opcion.value = provincia[1];
            opcion.textContent = provincia[2];
            opcion.setAttribute('data-prefijo', provincia[0]);
            selector.appendChild(opcion);
          });
        }
        var guardados = leerDatos();
        ['nombre', 'telefono', 'direccion', 'piso', 'cp', 'provincia', 'ciudad', 'email'].forEach(function (nombre) {
          var entrada = campo(nombre);
          if (!entrada) return;
          if (guardados[nombre]) entrada.value = guardados[nombre];
          entrada.addEventListener('blur', function () {
            if (entrada.value) validarCampo(nombre);
          });
          entrada.addEventListener('input', function () {
            var caja = entrada.closest('.yume-lp-campo');
            if (caja.classList.contains('yume-lp-campo--error')) validarCampo(nombre);
          });
        });
        var codigoPostal = campo('cp');
        if (codigoPostal && selector) {
          codigoPostal.addEventListener('input', function () {
            codigoPostal.value = codigoPostal.value.replace(/\D/g, '').slice(0, 5);
            if (codigoPostal.value.length >= 2) {
              var prefijo = codigoPostal.value.slice(0, 2);
              cada(selector.options, function (opcion) {
                if (opcion.getAttribute('data-prefijo') === prefijo) {
                  selector.value = opcion.value;
                  validarCampo('provincia');
                }
              });
            }
          });
        }
        cada(modal.querySelectorAll('[data-yume-lp-pagar]'), function (botonPago) {
          botonPago.addEventListener('click', function () {
            pagoElegido = botonPago.value;
          });
        });
        cada(modal.querySelectorAll('[data-yume-lp-cerrar]'), function (cerrador) {
          cerrador.addEventListener('click', cerrarFormulario);
        });
        modal.addEventListener('keydown', function (evento) {
          if (evento.key === 'Escape') cerrarFormulario();
        });
        var formulario = modal.querySelector('[data-yume-lp-form]');
        formulario.addEventListener('submit', function (evento) {
          evento.preventDefault();
          if (evento.submitter && evento.submitter.value) pagoElegido = evento.submitter.value;
          enviarFormulario();
        });
      }

      function abrirFormulario() {
        if (!modal) return;
        prepararFormulario();
        pintarFormulario();
        focoPrevio = document.activeElement;
        modal.hidden = false;
        document.body.style.overflow = 'hidden';
        window.requestAnimationFrame(function () {
          window.requestAnimationFrame(function () {
            modal.classList.add('yume-lp-modal--abierto');
          });
        });
        var primero = campo('nombre');
        if (primero && !primero.value) window.setTimeout(function () { primero.focus({ preventScroll: true }); }, 420);
        var datos = calcular(packActivo());
        registrar('yume_open_form', datos.unidades, datos.total);
      }

      function cerrarFormulario() {
        if (!modal || modal.hidden) return;
        modal.classList.remove('yume-lp-modal--abierto');
        document.body.style.overflow = '';
        window.setTimeout(function () {
          if (!modal.classList.contains('yume-lp-modal--abierto')) modal.hidden = true;
        }, movimientoReducido ? 0 : 400);
        if (focoPrevio && focoPrevio.focus) focoPrevio.focus({ preventScroll: true });
      }

      function borrarCodigoGuardado() {
        var dominio = window.location.hostname;
        var partes = dominio.split('.');
        var dominios = ['', ';domain=' + dominio, ';domain=.' + dominio];
        if (partes.length > 2) dominios.push(';domain=.' + partes.slice(-2).join('.'));
        dominios.forEach(function (extra) {
          document.cookie = 'discount_code=;path=/;max-age=0;expires=Thu, 01 Jan 1970 00:00:00 GMT' + extra;
        });
      }

      function enviarFormulario() {
        var nombres = ['nombre', 'telefono', 'direccion', 'cp', 'provincia', 'ciudad', 'email', 'piso'];
        var primerError = null;
        nombres.forEach(function (nombre) {
          if (!validarCampo(nombre) && !primerError) primerError = campo(nombre);
        });
        var errorGeneral = modal.querySelector('[data-yume-lp-form-error]');
        if (primerError) {
          if (errorGeneral) errorGeneral.hidden = false;
          primerError.focus();
          return;
        }
        if (errorGeneral) errorGeneral.hidden = true;
        if (!estado.variante || raiz.getAttribute('data-producto') !== 'true') return;

        var valores = {};
        nombres.forEach(function (nombre) {
          var entrada = campo(nombre);
          valores[nombre] = entrada ? limpiar(entrada.value) : '';
        });
        guardarDatos(valores);

        var partesNombre = valores.nombre.split(' ');
        var nombrePila = partesNombre.shift();
        var apellidos = partesNombre.join(' ');
        var datos = calcular(packActivo());
        var parametros = [
          ['checkout[shipping_address][first_name]', nombrePila],
          ['checkout[shipping_address][last_name]', apellidos],
          ['checkout[shipping_address][address1]', valores.direccion],
          ['checkout[shipping_address][address2]', valores.piso],
          ['checkout[shipping_address][zip]', valores.cp],
          ['checkout[shipping_address][city]', valores.ciudad],
          ['checkout[shipping_address][province]', valores.provincia],
          ['checkout[shipping_address][country]', 'ES'],
          ['checkout[shipping_address][phone]', '+34' + telefonoLimpio(valores.telefono)],
          ['checkout[email]', valores.email]
        ];
        var ofertaPedido = raiz.querySelector('[data-yume-lp-oferta]');
        var regalosPedido = regalosIncluidos();
        if (ofertaPedido && regalosPedido.length && ofertaPedido.getAttribute('data-atributo')) {
          parametros.push(['attributes[' + ofertaPedido.getAttribute('data-atributo') + ']', regalosPedido.join(', ')]);
        }
        var atributo = raiz.getAttribute('data-form-atributo');
        if (atributo) {
          parametros.push(['attributes[' + atributo + ']', pagoElegido === 'tarjeta' ? raiz.getAttribute('data-form-valor-tarjeta') : raiz.getAttribute('data-form-valor-cod')]);
        }
        if (datos.pack) parametros.push(['attributes[Pack]', datos.pack]);
        parametros.push(['attributes[Unidades a enviar]', String(datos.unidades)]);
        var codigo = raiz.getAttribute('data-form-codigo');
        if (pagoElegido === 'tarjeta' && codigo) {
          parametros.push(['discount', codigo]);
        } else {
          borrarCodigoGuardado();
        }
        var consulta = parametros.filter(function (par) { return par[1]; }).map(function (par) {
          return encodeURIComponent(par[0]) + '=' + encodeURIComponent(par[1]);
        }).join('&');
        var raizTienda = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

        cada(modal.querySelectorAll('[data-yume-lp-pagar]'), function (botonPago) { botonPago.disabled = true; });
        var total = pagoElegido === 'tarjeta' ? datos.total - descuentoTarjeta(datos.total) : datos.total;
        registrar(pagoElegido === 'tarjeta' ? 'yume_checkout_tarjeta' : 'yume_checkout_reembolso', datos.unidades, total);
        var destino = raizTienda + 'cart/' + estado.variante + ':' + datos.cantidad + '?' + consulta;
        celebrarPago(pagoElegido, function () { window.location.href = destino; });
      }

      function comprar(origen) {
        if (!estado.variante || raiz.getAttribute('data-producto') !== 'true') return;
        if (raiz.getAttribute('data-accion') === 'formulario' && modal) {
          abrirFormulario();
          return;
        }
        var datos = calcular(packActivo());
        if (raiz.getAttribute('data-accion') === 'checkout') {
          registrar('yume_initiate_checkout', datos.unidades, datos.total);
          window.location.href = ((window.routes && window.routes.cart_url) || '/cart') + '/' + estado.variante + ':' + datos.cantidad;
          return;
        }
        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        boton.disabled = true;
        boton.setAttribute('aria-busy', 'true');
        textoBoton.textContent = raiz.getAttribute('data-texto-cargando') || '';
        anadirAlCarrito(Number(estado.variante), datos.cantidad, origen)
          .then(function (respuesta) {
            if (respuesta && respuesta.status) {
              if (error) {
                error.textContent = respuesta.description || respuesta.message || '';
                error.hidden = false;
              }
              return;
            }
            registrar('yume_add_to_cart', datos.unidades, datos.total);
          })
          .catch(function () {
            if (error) {
              error.textContent = raiz.getAttribute('data-texto-error') || '';
              error.hidden = false;
            }
          })
          .then(function () {
            boton.removeAttribute('aria-busy');
            pintar();
          });
      }

      if (boton) boton.addEventListener('click', function () { comprar('yume-landing'); });
      if (botonBarra) botonBarra.addEventListener('click', function () { comprar('yume-landing-barra'); });

      var envio = raiz.querySelector('[data-yume-lp-envio]');
      var plantillaEnvio = raiz.getAttribute('data-envio-texto');
      if (envio && plantillaEnvio) {
        var sumar = function (dias) {
          var fecha = new Date();
          var sumados = 0;
          while (sumados < dias) {
            fecha.setDate(fecha.getDate() + 1);
            var dia = fecha.getDay();
            if (dia !== 0 && dia !== 6) sumados += 1;
          }
          return fecha;
        };
        var minimo = Number(raiz.getAttribute('data-envio-min')) || 2;
        var maximo = Math.max(minimo, Number(raiz.getAttribute('data-envio-max')) || minimo);
        var formateador = new Intl.DateTimeFormat(document.documentElement.lang || 'es', { weekday: 'short', day: 'numeric', month: 'short' });
        var partes = plantillaEnvio.split(/(\[\[fecha_min\]\]|\[\[fecha_max\]\])/);
        envio.textContent = '';
        partes.forEach(function (parte) {
          if (parte === '[[fecha_min]]' || parte === '[[fecha_max]]') {
            var negrita = document.createElement('b');
            negrita.textContent = formateador.format(sumar(parte === '[[fecha_min]]' ? minimo : maximo));
            envio.appendChild(negrita);
          } else {
            envio.appendChild(document.createTextNode(parte));
          }
        });
      }

      var postura = raiz.querySelector('[data-yume-lp-postura]');
      if (postura) {
        var textos = {};
        var plantilla = postura.querySelector('[data-yume-lp-textos]');
        if (plantilla && plantilla.content) {
          cada(plantilla.content.querySelectorAll('[data-clave]'), function (nodo) {
            textos[nodo.getAttribute('data-clave')] = nodo.textContent;
          });
        }
        var titulo = postura.querySelector('[data-yume-lp-rec-titulo]');
        var texto = postura.querySelector('[data-yume-lp-rec-texto]');
        var nota = postura.querySelector('[data-yume-lp-rec-nota]');
        var actualizarPostura = function () {
          var tipo = postura.getAttribute('data-postura');
          var complexion = postura.getAttribute('data-complexion');
          postura.classList.add('yume-lp-cambiando');
          window.setTimeout(function () {
            if (titulo) titulo.textContent = textos[tipo + '-titulo'] || '';
            if (texto) texto.textContent = textos[tipo + '-texto'] || '';
            if (nota) {
              var claveNota = complexion === 'menuda' ? 'nota-menuda' : (complexion === 'ancha' ? 'nota-ancha' : '');
              nota.hidden = !claveNota || !textos[claveNota];
              if (claveNota) nota.textContent = textos[claveNota] || '';
            }
            postura.classList.remove('yume-lp-cambiando');
          }, movimientoReducido ? 0 : 180);
        };
        cada(postura.querySelectorAll('.yume-lp-chip'), function (chip) {
          chip.addEventListener('click', function () {
            var grupo = chip.getAttribute('data-grupo');
            cada(postura.querySelectorAll('.yume-lp-chip[data-grupo="' + grupo + '"]'), function (otro) {
              var activo = otro === chip;
              otro.classList.toggle('yume-lp-activa', activo);
              otro.setAttribute('aria-checked', activo ? 'true' : 'false');
            });
            postura.setAttribute('data-' + grupo, chip.getAttribute('data-valor'));
            actualizarPostura();
          });
        });
      }

      var faq = raiz.querySelector('[data-yume-lp-faq]');
      if (faq) {
        var detalles = faq.querySelectorAll('details');
        cada(detalles, function (detalle) {
          detalle.addEventListener('toggle', function () {
            if (!detalle.open) return;
            cada(detalles, function (otro) {
              if (otro !== detalle && otro.open) otro.open = false;
            });
          });
        });
      }

      function actualizarChipsAhorro() {
        if (!posPack || !packs.length) return;
        var opcionesUno = opcionesActuales.slice();
        opcionesUno[posPack - 1] = packs[0].getAttribute('data-valor');
        var datoUno = buscarVariante(opcionesUno);
        var unidadesUno = Number(packs[0].getAttribute('data-unidades')) || 1;
        cada(packs, function (pack) {
          var chip = pack.querySelector('[data-yume-lp-pack-ahorro]');
          if (!chip) return;
          var opciones = opcionesActuales.slice();
          opciones[posPack - 1] = pack.getAttribute('data-valor');
          var dato = buscarVariante(opciones);
          var unidades = Number(pack.getAttribute('data-unidades')) || 1;
          var ahorro = dato && datoUno && unidades > unidadesUno ? Math.round((datoUno.precio / unidadesUno) * unidades - dato.precio) : 0;
          chip.hidden = ahorro <= 0;
          if (ahorro > 0) chip.textContent = (chip.getAttribute('data-plantilla') || '').replace('[[ahorro]]', formatearDinero(ahorro, formato));
        });
      }

      var efectosActivos = raiz.getAttribute('data-efectos') === 'true' && !movimientoReducido;
      var puedeAnimar = efectosActivos && typeof raiz.animate === 'function';
      var capaConfeti = raiz.querySelector('[data-yume-lp-confeti]');
      var cajaAhorro = raiz.querySelector('[data-yume-lp-ahorro]');

      function vibrar(patron) {
        if (!efectosActivos || !navigator.vibrate) return;
        try { navigator.vibrate(patron); } catch (e) {}
      }

      function colorTema(nombre, respaldo) {
        var valor = window.getComputedStyle(raiz).getPropertyValue(nombre);
        return valor && valor.trim() ? valor.trim() : respaldo;
      }

      function confeti(origen, cantidad) {
        if (!puedeAnimar || !capaConfeti || !origen) return;
        var caja = origen.getBoundingClientRect();
        var x = caja.left + caja.width / 2;
        var y = caja.top + caja.height / 2;
        var colores = [colorTema('--yume-lp-acento', '#C9805F'), colorTema('--yume-lp-estrellas', '#E3B04B'), colorTema('--yume-lp-boton', '#2B2622'), colorTema('--yume-lp-acento-suave', '#F3D9C9'), '#FFFFFF'];
        for (var i = 0; i < cantidad; i += 1) {
          var pieza = document.createElement('span');
          var forma = i % 5;
          var color = colores[i % colores.length];
          pieza.className = 'yume-lp-confeti__pieza' + (forma === 0 ? ' yume-lp-confeti__pieza--estrella' : forma === 1 ? ' yume-lp-confeti__pieza--redonda' : '');
          if (forma === 0) {
            pieza.textContent = '✦';
            pieza.style.color = colores[1];
            pieza.style.background = 'transparent';
          } else {
            pieza.style.background = color;
          }
          pieza.style.left = (x + (Math.random() - 0.5) * caja.width * 0.7) + 'px';
          pieza.style.top = (y + (Math.random() - 0.5) * caja.height * 0.4) + 'px';
          capaConfeti.appendChild(pieza);
          var angulo = -Math.PI * (0.1 + Math.random() * 0.8);
          var fuerza = 80 + Math.random() * 170;
          var dx = Math.cos(angulo) * fuerza;
          var dy = Math.sin(angulo) * fuerza;
          var giro = (Math.random() - 0.5) * 900;
          var animacion = pieza.animate([
            { transform: 'translate(-50%, -50%) translate(0px, 0px) rotate(0deg) scale(0.4)', opacity: 1 },
            { transform: 'translate(-50%, -50%) translate(' + dx + 'px, ' + dy + 'px) rotate(' + (giro / 2) + 'deg) scale(1)', opacity: 1, offset: 0.4 },
            { transform: 'translate(-50%, -50%) translate(' + (dx * 1.25) + 'px, ' + (dy + 190) + 'px) rotate(' + giro + 'deg) scale(0.8)', opacity: 0 }
          ], { duration: 950 + Math.random() * 550, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' });
          animacion.onfinish = (function (elemento) {
            return function () { if (elemento.parentNode) elemento.parentNode.removeChild(elemento); };
          })(pieza);
        }
      }

      function onda(elemento, evento) {
        if (!puedeAnimar || !evento || typeof evento.clientX !== 'number') return;
        var marco = elemento.querySelector('.yume-lp-brillo');
        if (!marco) return;
        var caja = elemento.getBoundingClientRect();
        var tam = Math.max(caja.width, caja.height);
        var circulo = document.createElement('span');
        circulo.className = 'yume-lp-onda';
        circulo.style.width = tam + 'px';
        circulo.style.height = tam + 'px';
        circulo.style.left = (evento.clientX - caja.left - tam / 2) + 'px';
        circulo.style.top = (evento.clientY - caja.top - tam / 2) + 'px';
        marco.appendChild(circulo);
        var animacion = circulo.animate([
          { transform: 'scale(0)', opacity: 0.6 },
          { transform: 'scale(2.4)', opacity: 0 }
        ], { duration: 650, easing: 'ease-out', fill: 'forwards' });
        animacion.onfinish = function () { if (circulo.parentNode) circulo.parentNode.removeChild(circulo); };
      }

      function latido(elemento, fuerza) {
        if (!puedeAnimar || !elemento) return;
        elemento.animate([
          { scale: '1' },
          { scale: String(1 - fuerza / 2) },
          { scale: String(1 + fuerza) },
          { scale: '1' }
        ], { duration: 460, easing: 'ease-out' });
      }

      function contarPrecio(desde, hasta) {
        if (!puedeAnimar || desde === hasta || !desde) return;
        var elementos = raiz.querySelectorAll('[data-yume-lp-precio]');
        var inicio = null;
        var duracion = 600;
        var paso = function (tiempo) {
          if (inicio === null) inicio = tiempo;
          var avance = Math.min((tiempo - inicio) / duracion, 1);
          var suave = 1 - Math.pow(1 - avance, 3);
          var valor = avance < 1 ? Math.round(desde + (hasta - desde) * suave) : hasta;
          cada(elementos, function (elemento) { elemento.textContent = formatearDinero(valor, formato); });
          if (avance < 1) window.requestAnimationFrame(paso);
        };
        window.requestAnimationFrame(paso);
      }

      function mostrarAhorro(pack) {
        if (!cajaAhorro) return;
        if (!pack || !posPack || !packs.length) {
          cajaAhorro.hidden = true;
          return;
        }
        var unidades = Number(pack.getAttribute('data-unidades')) || 1;
        var opciones = opcionesActuales.slice();
        opciones[posPack - 1] = packs[0].getAttribute('data-valor');
        var datoUno = buscarVariante(opciones);
        var unidadesUno = Number(packs[0].getAttribute('data-unidades')) || 1;
        var ahorro = datoUno && unidades > unidadesUno ? Math.round((datoUno.precio / unidadesUno) * unidades - estado.precio) : 0;
        if (ahorro <= 0) {
          cajaAhorro.hidden = true;
          return;
        }
        var estabaOculta = cajaAhorro.hidden;
        cajaAhorro.textContent = (cajaAhorro.getAttribute('data-plantilla') || '').replace('[[ahorro]]', formatearDinero(ahorro, formato));
        cajaAhorro.hidden = false;
        if (puedeAnimar) {
          cajaAhorro.animate([
            { opacity: 0, transform: 'translateY(8px) scale(0.96)' },
            { opacity: 1, transform: 'translateY(0) scale(1.02)', offset: 0.7 },
            { opacity: 1, transform: 'translateY(0) scale(1)' }
          ], { duration: estabaOculta ? 460 : 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        }
      }

      function efectoPack(pack, precioAntes) {
        mostrarAhorro(pack);
        contarPrecio(precioAntes, estado.precio);
        vibrar(12);
        if (!puedeAnimar || !pack) return;
        latido(pack, 0.03);
        var unidades = Number(pack.getAttribute('data-unidades')) || 1;
        if (unidades > 1) confeti(pack, 8 + unidades * 7);
        if (boton) {
          boton.animate([
            { translate: '0 0' },
            { translate: '0 -4px' },
            { translate: '0 0' }
          ], { duration: 420, easing: 'ease-out' });
        }
      }

      function celebrarPago(tipo, seguir) {
        var botonPago = modal ? modal.querySelector('.yume-lp-pagar--' + (tipo === 'tarjeta' ? 'tarjeta' : 'cod')) : null;
        if (!puedeAnimar || !botonPago) {
          seguir();
          return;
        }
        vibrar([12, 40, 20]);
        botonPago.classList.add('yume-lp-pagar--celebrando');
        latido(botonPago, 0.04);
        confeti(botonPago, tipo === 'tarjeta' ? 40 : 30);
        var hecho = false;
        var continuar = function () {
          if (hecho) return;
          hecho = true;
          seguir();
        };
        window.setTimeout(continuar, 700);
      }

      cada(raiz.querySelectorAll('.yume-lp-boton, .yume-lp-pagar'), function (elemento) {
        elemento.addEventListener('pointerdown', function (evento) { onda(elemento, evento); });
      });

      if (packActivo()) mostrarAhorro(packActivo());

      if (puedeAnimar) {
        cada(raiz.querySelectorAll('[data-yume-lp-brillo]'), function (marco, indice) {
          var destello = marco.querySelector('.yume-lp-destello');
          if (!destello) return;
          var duracion = Number(marco.getAttribute('data-yume-lp-brillo')) || 4000;
          destello.animate([
            { transform: 'translateX(0) skewX(-20deg)', offset: 0 },
            { transform: 'translateX(460%) skewX(-20deg)', offset: 0.32 },
            { transform: 'translateX(460%) skewX(-20deg)', offset: 1 }
          ], { duration: duracion, delay: 500 + (indice % 4) * 650, iterations: Infinity, easing: 'ease-in-out' });
        });
        if (boton) {
          boton.animate([
            { scale: '1' },
            { scale: '1.025' },
            { scale: '1' }
          ], { duration: 2600, iterations: Infinity, easing: 'ease-in-out' });
        }
        var estrella = raiz.querySelector('[data-yume-lp-estrella]');
        if (estrella) {
          var conico = estrella.querySelector('.yume-lp-pack__conico');
          if (conico) {
            conico.animate([
              { transform: 'rotate(0deg)' },
              { transform: 'rotate(360deg)' }
            ], { duration: 3000, iterations: Infinity, easing: 'linear' });
          }
          estrella.animate([
            { translate: '0 0', scale: '1', offset: 0 },
            { translate: '0 -3px', scale: '1', offset: 0.25 },
            { translate: '0 0', scale: '1', offset: 0.5 },
            { translate: '0 -3px', scale: '1.025', offset: 0.62 },
            { translate: '0 0', scale: '0.995', offset: 0.7 },
            { translate: '0 -2px', scale: '1.015', offset: 0.78 },
            { translate: '0 0', scale: '1', offset: 1 }
          ], { duration: 3600, iterations: Infinity, easing: 'ease-in-out' });
          cada(estrella.querySelectorAll('.yume-lp-pack__chispa'), function (chispa, indice) {
            chispa.animate([
              { opacity: 0, transform: 'scale(0.2) rotate(0deg)', offset: 0 },
              { opacity: 1, transform: 'scale(1.15) rotate(90deg)', offset: 0.18 },
              { opacity: 0.9, transform: 'scale(0.9) rotate(150deg)', offset: 0.3 },
              { opacity: 0, transform: 'scale(0.2) rotate(220deg)', offset: 0.45 },
              { opacity: 0, transform: 'scale(0.2) rotate(220deg)', offset: 1 }
            ], { duration: 2000, delay: indice * 400, iterations: Infinity, easing: 'ease-out' });
          });
          var precioEstrella = estrella.querySelector('.yume-lp-pack__ahorro');
          if (precioEstrella) {
            precioEstrella.animate([
              { scale: '1', offset: 0 },
              { scale: '1.12', offset: 0.12 },
              { scale: '1', offset: 0.24 },
              { scale: '1', offset: 1 }
            ], { duration: 2200, iterations: Infinity, easing: 'ease-out' });
          }
          if ('IntersectionObserver' in window) {
            var vistoEstrella = new IntersectionObserver(function (entradas) {
              entradas.forEach(function (entrada) {
                if (!entrada.isIntersecting) return;
                vistoEstrella.disconnect();
                window.setTimeout(function () {
                  confeti(estrella, 22);
                  latido(estrella, 0.04);
                }, 450);
              });
            }, { threshold: 0.8 });
            vistoEstrella.observe(estrella);
          }
          var aura = estrella.querySelector('.yume-lp-pack__aura');
          if (aura) {
            aura.animate([
              { opacity: 0 },
              { opacity: 1, offset: 0.5 },
              { opacity: 0 }
            ], { duration: 2400, iterations: Infinity, easing: 'ease-in-out' });
          }
          var etiquetaEstrella = estrella.querySelector('.yume-lp-pack__badge');
          if (etiquetaEstrella) {
            etiquetaEstrella.animate([
              { translate: '0 0', rotate: '0deg', offset: 0 },
              { translate: '0 -4px', rotate: '-3deg', offset: 0.08 },
              { translate: '0 0', rotate: '2deg', offset: 0.16 },
              { translate: '0 -2px', rotate: '0deg', offset: 0.22 },
              { translate: '0 0', rotate: '0deg', offset: 0.3 },
              { translate: '0 0', rotate: '0deg', offset: 1 }
            ], { duration: 3200, iterations: Infinity, easing: 'ease-in-out' });
          }
        }
        cada(raiz.querySelectorAll('.yume-lp-pagar__flecha, .yume-lp-boton .yume-lp-icono--flecha'), function (flecha) {
          flecha.animate([
            { translate: '0 0' },
            { translate: '4px 0', offset: 0.5 },
            { translate: '0 0' }
          ], { duration: 1400, iterations: Infinity, easing: 'ease-in-out' });
        });
        var etiquetaTarjeta = raiz.querySelector('.yume-lp-pagar__etiqueta');
        if (etiquetaTarjeta) {
          etiquetaTarjeta.animate([
            { scale: '1', offset: 0 },
            { scale: '1.12', offset: 0.1 },
            { scale: '1', offset: 0.2 },
            { scale: '1.08', offset: 0.3 },
            { scale: '1', offset: 0.4 },
            { scale: '1', offset: 1 }
          ], { duration: 2800, iterations: Infinity, easing: 'ease-in-out' });
        }
      }

      var celebrarOferta = false;

      function contarDinero(nodo, hasta) {
        if (!nodo) return;
        var desde = Number(nodo.getAttribute('data-centimos'));
        nodo.setAttribute('data-centimos', hasta);
        if (!puedeAnimar || isNaN(desde) || desde === hasta || nodo.getAttribute('data-centimos-listo') !== 'true') {
          nodo.textContent = formatearDinero(hasta, formato);
          nodo.setAttribute('data-centimos-listo', 'true');
          return;
        }
        var inicio = null;
        var paso = function (tiempo) {
          if (inicio === null) inicio = tiempo;
          var avance = Math.min((tiempo - inicio) / 650, 1);
          var suave = 1 - Math.pow(1 - avance, 3);
          nodo.textContent = formatearDinero(avance < 1 ? Math.round(desde + (hasta - desde) * suave) : hasta, formato);
          if (avance < 1) window.requestAnimationFrame(paso);
        };
        window.requestAnimationFrame(paso);
      }

      function textoFlotante(origen, texto) {
        if (!puedeAnimar || !capaConfeti || !origen || !texto) return;
        var caja = origen.getBoundingClientRect();
        var etiqueta = document.createElement('span');
        etiqueta.className = 'yume-lp-flotante';
        etiqueta.textContent = texto;
        etiqueta.style.left = (caja.left + caja.width / 2) + 'px';
        etiqueta.style.top = (caja.top + caja.height / 2) + 'px';
        capaConfeti.appendChild(etiqueta);
        var animacion = etiqueta.animate([
          { transform: 'translate(-50%, -50%) scale(0.4)', opacity: 0 },
          { transform: 'translate(-50%, -90%) scale(1.15)', opacity: 1, offset: 0.25 },
          { transform: 'translate(-50%, -150%) scale(1)', opacity: 1, offset: 0.7 },
          { transform: 'translate(-50%, -210%) scale(0.95)', opacity: 0 }
        ], { duration: 1500, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)', fill: 'forwards' });
        animacion.onfinish = function () { if (etiqueta.parentNode) etiqueta.parentNode.removeChild(etiqueta); };
      }

      function onda360(origen, color) {
        if (!puedeAnimar || !capaConfeti || !origen) return;
        var caja = origen.getBoundingClientRect();
        for (var i = 0; i < 2; i += 1) {
          var anillo = document.createElement('span');
          anillo.className = 'yume-lp-anillo';
          anillo.style.left = (caja.left + caja.width / 2) + 'px';
          anillo.style.top = (caja.top + caja.height / 2) + 'px';
          anillo.style.borderColor = color;
          capaConfeti.appendChild(anillo);
          var animacion = anillo.animate([
            { transform: 'translate(-50%, -50%) scale(0.2)', opacity: 0.9 },
            { transform: 'translate(-50%, -50%) scale(' + (3.2 + i * 1.4) + ')', opacity: 0 }
          ], { duration: 900 + i * 250, delay: i * 120, easing: 'cubic-bezier(0.1, 0.7, 0.3, 1)', fill: 'both' });
          animacion.onfinish = (function (nodo) { return function () { if (nodo.parentNode) nodo.parentNode.removeChild(nodo); }; })(anillo);
        }
      }

      function radar(elemento, color, duracion, retraso) {
        if (!puedeAnimar || !elemento) return;
        var anillo = document.createElement('span');
        anillo.className = 'yume-lp-radar';
        anillo.setAttribute('aria-hidden', 'true');
        anillo.style.opacity = '0';
        anillo.style.borderColor = color;
        elemento.appendChild(anillo);
        anillo.animate([
          { transform: 'scale(1, 1)', opacity: 0.75, offset: 0 },
          { transform: 'scale(1.08, 1.45)', opacity: 0, offset: 0.55 },
          { transform: 'scale(1.08, 1.45)', opacity: 0, offset: 1 }
        ], { duration: duracion, delay: retraso || 0, iterations: Infinity, easing: 'ease-out' });
      }

      function animarBotonesCompra() {
        if (!puedeAnimar) return;
        var acento = colorTema('--yume-lp-acento', '#C9805F');
        var dorado = colorTema('--yume-lp-estrellas', '#E3B04B');
        if (boton) {
          radar(boton, acento, 2200, 0);
          radar(boton, dorado, 2200, 1100);
          boton.animate([
            { rotate: '0deg', offset: 0 },
            { rotate: '0deg', offset: 0.8 },
            { rotate: '-2.5deg', offset: 0.84 },
            { rotate: '2.5deg', offset: 0.88 },
            { rotate: '-1.5deg', offset: 0.92 },
            { rotate: '1deg', offset: 0.96 },
            { rotate: '0deg', offset: 1 }
          ], { duration: 5200, iterations: Infinity, easing: 'ease-in-out' });
        }
        cada(raiz.querySelectorAll('.yume-lp-barra__boton'), function (botonBarraFx) {
          radar(botonBarraFx, acento, 2600, 400);
          botonBarraFx.animate([
            { translate: '0 0', offset: 0 },
            { translate: '0 0', offset: 0.7 },
            { translate: '0 -7px', offset: 0.76 },
            { translate: '0 0', offset: 0.82 },
            { translate: '0 -4px', offset: 0.87 },
            { translate: '0 0', offset: 0.92 },
            { translate: '0 0', offset: 1 }
          ], { duration: 4200, iterations: Infinity, easing: 'ease-in-out' });
        });
        cada(raiz.querySelectorAll('.yume-lp-final .yume-lp-boton, .yume-lp-inversion__pie .yume-lp-boton'), function (cta) {
          radar(cta, dorado, 2600, 300);
        });
        var cod = raiz.querySelector('.yume-lp-pagar--cod');
        if (cod) {
          radar(cod, colorTema('--yume-lp-boton', '#2B2622'), 2600, 0);
          var iconoCod = cod.querySelector('.yume-lp-pagar__icono');
          if (iconoCod) {
            iconoCod.animate([
              { translate: '0 0', rotate: '0deg' },
              { translate: '0 -3px', rotate: '-6deg', offset: 0.5 },
              { translate: '0 0', rotate: '0deg' }
            ], { duration: 1800, iterations: Infinity, easing: 'ease-in-out' });
          }
        }
        var tarjeta = raiz.querySelector('.yume-lp-pagar--tarjeta');
        if (tarjeta) {
          radar(tarjeta, acento, 1800, 0);
          radar(tarjeta, dorado, 1800, 900);
          var iconoTarjeta = tarjeta.querySelector('.yume-lp-pagar__icono');
          if (iconoTarjeta) {
            iconoTarjeta.animate([
              { transform: 'perspective(200px) rotateY(0deg)', offset: 0 },
              { transform: 'perspective(200px) rotateY(0deg)', offset: 0.6 },
              { transform: 'perspective(200px) rotateY(360deg) scale(1.2)', offset: 0.85 },
              { transform: 'perspective(200px) rotateY(360deg) scale(1)', offset: 1 }
            ], { duration: 3000, iterations: Infinity, easing: 'ease-in-out' });
          }
          tarjeta.animate([
            { scale: '1', offset: 0 },
            { scale: '1', offset: 0.72 },
            { scale: '1.03', offset: 0.8 },
            { scale: '0.99', offset: 0.88 },
            { scale: '1', offset: 1 }
          ], { duration: 3000, iterations: Infinity, easing: 'ease-in-out' });
        }
      }

      function animarOfertaContinua() {
        var oferta = raiz.querySelector('[data-yume-lp-oferta]');
        if (!oferta || !puedeAnimar) return;
        var cajaRegalo = oferta.querySelector('.yume-lp-oferta__caja');
        if (cajaRegalo) {
          cajaRegalo.animate([
            { rotate: '0deg', scale: '1', offset: 0 },
            { rotate: '0deg', scale: '1', offset: 0.62 },
            { rotate: '-12deg', scale: '1.12', offset: 0.68 },
            { rotate: '10deg', scale: '1.12', offset: 0.74 },
            { rotate: '-8deg', scale: '1.08', offset: 0.8 },
            { rotate: '6deg', scale: '1.04', offset: 0.86 },
            { rotate: '0deg', scale: '1', offset: 0.92 },
            { rotate: '0deg', scale: '1', offset: 1 }
          ], { duration: 3200, iterations: Infinity, easing: 'ease-in-out' });
        }
        var relleno = oferta.querySelector('.yume-lp-oferta__relleno');
        if (relleno) {
          var reflejo = document.createElement('span');
          reflejo.className = 'yume-lp-oferta__reflejo';
          relleno.appendChild(reflejo);
          reflejo.animate([
            { transform: 'translateX(-100%)' },
            { transform: 'translateX(400%)' }
          ], { duration: 1800, iterations: Infinity, easing: 'ease-in-out' });
        }
        cada(oferta.querySelectorAll('[data-yume-lp-regalo]'), function (regalo, indice) {
          var marco = document.createElement('span');
          marco.className = 'yume-lp-brillo';
          marco.setAttribute('aria-hidden', 'true');
          var destello = document.createElement('span');
          destello.className = 'yume-lp-destello';
          marco.appendChild(destello);
          regalo.appendChild(marco);
          destello.animate([
            { transform: 'translateX(0) skewX(-20deg)', offset: 0 },
            { transform: 'translateX(460%) skewX(-20deg)', offset: 0.3 },
            { transform: 'translateX(460%) skewX(-20deg)', offset: 1 }
          ], { duration: 3600, delay: indice * 450, iterations: Infinity, easing: 'ease-in-out' });
        });
        window.setInterval(function () {
          if (document.hidden) return;
          cada(oferta.querySelectorAll('.yume-lp-oferta__regalo.yume-lp-desbloqueado .yume-lp-oferta__icono'), function (icono, indice) {
            icono.animate([
              { translate: '0 0', rotate: '0deg', scale: '1' },
              { translate: '0 -8px', rotate: '-10deg', scale: '1.15', offset: 0.35 },
              { translate: '0 0', rotate: '6deg', scale: '0.95', offset: 0.65 },
              { translate: '0 0', rotate: '0deg', scale: '1' }
            ], { duration: 650, delay: indice * 160, easing: 'ease-out' });
          });
          var siguiente = oferta.querySelector('.yume-lp-oferta__regalo.yume-lp-siguiente');
          if (siguiente) {
            siguiente.animate([
              { translate: '0 0', boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)' },
              { translate: '-5px 0', boxShadow: '0 0 0 4px ' + colorTema('--yume-lp-acento-suave', '#F3D9C9'), offset: 0.15 },
              { translate: '5px 0', offset: 0.3 },
              { translate: '-3px 0', offset: 0.45 },
              { translate: '2px 0', offset: 0.6 },
              { translate: '0 0', boxShadow: '0 0 0 0 rgba(0, 0, 0, 0)' }
            ], { duration: 800, easing: 'ease-in-out' });
            var candado = siguiente.querySelector('.yume-lp-oferta__candado');
            if (candado) {
              candado.animate([
                { rotate: '0deg' },
                { rotate: '-20deg', offset: 0.25 },
                { rotate: '18deg', offset: 0.5 },
                { rotate: '-10deg', offset: 0.75 },
                { rotate: '0deg' }
              ], { duration: 700, easing: 'ease-in-out' });
            }
          }
          var ventaja = oferta.querySelector('[data-yume-lp-oferta-ahorro]');
          if (ventaja && !ventaja.hidden) {
            ventaja.animate([
              { scale: '1' },
              { scale: '1.1', offset: 0.3 },
              { scale: '1' }
            ], { duration: 600, easing: 'ease-out' });
          }
        }, 2600);
      }

      function celebrarRegalo(regalo, oferta) {
        if (!puedeAnimar) return;
        regalo.animate([
          { transform: 'perspective(700px) rotateX(-80deg) scale(0.9)', opacity: 0.3 },
          { transform: 'perspective(700px) rotateX(12deg) scale(1.05)', opacity: 1, offset: 0.6 },
          { transform: 'perspective(700px) rotateX(0deg) scale(1)', opacity: 1 }
        ], { duration: 750, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        var icono = regalo.querySelector('.yume-lp-oferta__icono');
        if (icono) {
          icono.animate([
            { scale: '0.3', rotate: '-30deg' },
            { scale: '1.6', rotate: '15deg', offset: 0.5 },
            { scale: '1', rotate: '0deg' }
          ], { duration: 800, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        }
        var valor = regalo.getAttribute('data-valor');
        window.setTimeout(function () {
          onda360(icono || regalo, colorTema('--yume-lp-estrellas', '#E3B04B'));
          confeti(icono || regalo, 34);
          textoFlotante(regalo, valor ? '+ ' + valor + ' € ' + (oferta.getAttribute('data-texto-gratis') || '') : (oferta.getAttribute('data-texto-gratis') || ''));
        }, 120);
        var cajaRegalo = oferta.querySelector('.yume-lp-oferta__caja');
        if (cajaRegalo) {
          cajaRegalo.animate([
            { scale: '1', rotate: '0deg' },
            { scale: '1.4', rotate: '-15deg', offset: 0.3 },
            { scale: '0.9', rotate: '10deg', offset: 0.6 },
            { scale: '1', rotate: '0deg' }
          ], { duration: 700, easing: 'ease-out' });
        }
        vibrar([20, 40, 30]);
      }


      function centimosDeTexto(texto) {
        var limpio = String(texto || '').replace(/[^\d,\.]/g, '').replace(/\.(?=\d{3}(\D|$))/g, '').replace(',', '.');
        var numero = parseFloat(limpio);
        return isNaN(numero) ? 0 : Math.round(numero * 100);
      }

      function indicePackActivo() {
        var activo = packActivo();
        var indice = 1;
        cada(packs, function (pack, i) { if (pack === activo) indice = i + 1; });
        return indice;
      }

      function regalosIncluidos() {
        var oferta = raiz.querySelector('[data-yume-lp-oferta]');
        if (!oferta) return [];
        var indice = indicePackActivo();
        var nombres = [];
        cada(oferta.querySelectorAll('[data-yume-lp-regalo]'), function (regalo) {
          if (indice >= (Number(regalo.getAttribute('data-pack')) || 1)) nombres.push(regalo.getAttribute('data-nombre'));
        });
        return nombres;
      }

      function actualizarOferta() {
        var oferta = raiz.querySelector('[data-yume-lp-oferta]');
        if (!oferta) return;
        var celebrar = celebrarOferta;
        celebrarOferta = false;
        var indice = indicePackActivo();
        var total = packs.length > 1 ? packs.length : 1;
        var pista = oferta.querySelector('.yume-lp-oferta__pista');
        if (pista) {
          var progreso = total > 1 ? ((indice - 1) / (total - 1)) * 100 : 100;
          pista.style.setProperty('--yume-lp-progreso', progreso + '%');
          cada(pista.querySelectorAll('.yume-lp-oferta__hito'), function (hito, i) {
            hito.style.display = i < total ? '' : 'none';
            if (total === 2) hito.style.left = (i * 100) + '%';
            var yaAlcanzado = hito.classList.contains('yume-lp-alcanzado');
            hito.classList.toggle('yume-lp-alcanzado', i < indice);
            if (celebrar && puedeAnimar && !yaAlcanzado && i < indice) {
              hito.animate([
                { scale: '1' },
                { scale: '1.6' },
                { scale: '1' }
              ], { duration: 500, delay: 350, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
            }
          });
        }
        var valorRegalos = 0;
        cada(oferta.querySelectorAll('[data-yume-lp-regalo]'), function (regalo) {
          var necesita = Number(regalo.getAttribute('data-pack')) || 1;
          var abierto = indice >= necesita;
          var antes = regalo.classList.contains('yume-lp-desbloqueado');
          regalo.classList.toggle('yume-lp-desbloqueado', abierto);
          var estadoRegalo = regalo.querySelector('[data-yume-lp-regalo-estado]');
          if (estadoRegalo) estadoRegalo.textContent = abierto ? (oferta.getAttribute('data-texto-desbloqueado') || '') : (oferta.getAttribute('data-texto-bloqueado') || '').replace('[[n]]', necesita);
          if (abierto) valorRegalos += centimosDeTexto(regalo.getAttribute('data-valor'));
          if (abierto && !antes && celebrar) celebrarRegalo(regalo, oferta);
        });
        var marcadoSiguiente = false;
        cada(oferta.querySelectorAll('[data-yume-lp-regalo]'), function (regalo) {
          var necesita = Number(regalo.getAttribute('data-pack')) || 1;
          var esSiguiente = !marcadoSiguiente && indice < necesita;
          regalo.classList.toggle('yume-lp-siguiente', esSiguiente);
          if (esSiguiente) {
            marcadoSiguiente = true;
            var textoSig = oferta.getAttribute('data-texto-siguiente');
            var estadoSig = regalo.querySelector('[data-yume-lp-regalo-estado]');
            if (textoSig && estadoSig) estadoSig.textContent = textoSig.replace('[[n]]', necesita);
          }
        });
        var activo = packActivo();
        var unidades = activo ? Number(activo.getAttribute('data-unidades')) || 1 : 1;
        var separado = estado.precio;
        if (posPack && packs.length) {
          var opcionesUno = opcionesActuales.slice();
          opcionesUno[posPack - 1] = packs[0].getAttribute('data-valor');
          var datoUno = buscarVariante(opcionesUno);
          var unidadesUno = Number(packs[0].getAttribute('data-unidades')) || 1;
          if (datoUno) separado = Math.round((datoUno.precio / unidadesUno) * unidades);
        }
        var valorTotal = separado + valorRegalos;
        var ahorro = valorTotal - estado.precio;
        var poner = function (selector, texto) {
          var nodo = oferta.querySelector(selector);
          if (nodo) nodo.textContent = texto;
        };
        poner('[data-yume-lp-oferta-separado-texto]', (oferta.getAttribute('data-texto-separado') || '').replace('[[n]]', unidades));
        contarDinero(oferta.querySelector('[data-yume-lp-oferta-separado]'), separado);
        contarDinero(oferta.querySelector('[data-yume-lp-oferta-regalos]'), valorRegalos);
        contarDinero(oferta.querySelector('[data-yume-lp-oferta-total]'), valorTotal);
        contarDinero(oferta.querySelector('[data-yume-lp-oferta-hoy]'), estado.precio);
        var cajaVentaja = oferta.querySelector('[data-yume-lp-oferta-ahorro]');
        if (cajaVentaja) {
          cajaVentaja.hidden = ahorro <= 0;
          cajaVentaja.textContent = (oferta.getAttribute('data-texto-ahorras') || '').replace('[[ahorro]]', formatearDinero(ahorro, formato));
          if (celebrar && ahorro > 0 && puedeAnimar) {
            cajaVentaja.animate([
              { scale: '1' },
              { scale: '1.15' },
              { scale: '1' }
            ], { duration: 450, easing: 'ease-out' });
          }
        }
      }

      function iniciarCorte() {
        var oferta = raiz.querySelector('[data-yume-lp-oferta]');
        if (!oferta) return;
        var caja = oferta.querySelector('[data-yume-lp-oferta-corte]');
        var texto = oferta.querySelector('[data-yume-lp-oferta-corte-texto]');
        var hora = Number(oferta.getAttribute('data-hora-corte')) || 0;
        if (!caja || !texto || !hora) return;
        var laborables = oferta.getAttribute('data-laborables') === 'true';
        var dos = function (n) { return (n < 10 ? '0' : '') + n; };
        var tic = function () {
          var ahora = new Date();
          var dia = ahora.getDay();
          var limite = new Date(ahora.getFullYear(), ahora.getMonth(), ahora.getDate(), hora, 0, 0);
          var hoyVale = !(laborables && (dia === 0 || dia === 6)) && ahora < limite;
          if (hoyVale) {
            var resto = Math.floor((limite - ahora) / 1000);
            var tiempo = dos(Math.floor(resto / 3600)) + ':' + dos(Math.floor((resto % 3600) / 60)) + ':' + dos(resto % 60);
            texto.innerHTML = '';
            var partes = (oferta.getAttribute('data-texto-corte') || '').split('[[tiempo]]');
            texto.appendChild(document.createTextNode(partes[0] || ''));
            var negrita = document.createElement('b');
            negrita.textContent = tiempo;
            texto.appendChild(negrita);
            texto.appendChild(document.createTextNode(partes.slice(1).join('') || ''));
          } else {
            texto.textContent = oferta.getAttribute('data-texto-corte-despues') || '';
          }
          caja.hidden = !texto.textContent;
        };
        tic();
        window.setInterval(tic, 1000);
        var pulso = caja.querySelector('.yume-lp-oferta__pulso');
        if (pulso && puedeAnimar) {
          pulso.animate([
            { scale: '1', opacity: 1 },
            { scale: '1.6', opacity: 0.4 },
            { scale: '1', opacity: 1 }
          ], { duration: 1600, iterations: Infinity, easing: 'ease-in-out' });
        }
      }

      function finEnMadrid(texto) {
        var partes = String(texto || '').trim().match(/^(\d{4})-(\d{1,2})-(\d{1,2})(?:[ T](\d{1,2}):(\d{2}))?$/);
        if (!partes) return null;
        var y = Number(partes[1]);
        var mes = Number(partes[2]) - 1;
        var dia = Number(partes[3]);
        var hora = partes[4] ? Number(partes[4]) : 23;
        var minuto = partes[5] ? Number(partes[5]) : 59;
        var supuesto = Date.UTC(y, mes, dia, hora, minuto, partes[4] ? 0 : 59);
        var desfase = 60;
        try {
          var formato = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' });
          var trozos = {};
          formato.formatToParts(new Date(supuesto)).forEach(function (trozo) { trozos[trozo.type] = trozo.value; });
          var local = Date.UTC(Number(trozos.year), Number(trozos.month) - 1, Number(trozos.day), Number(trozos.hour) % 24, Number(trozos.minute));
          desfase = Math.round((local - supuesto) / 60000);
        } catch (e) {}
        return new Date(supuesto - desfase * 60000);
      }

      function iniciarUrgencia() {
        var urgencia = raiz.querySelector('[data-yume-lp-urgencia]');
        var avisoModal = modal ? modal.querySelector('[data-yume-lp-modal-urgencia]') : null;
        if (!urgencia) return;
        var reloj = urgencia.querySelector('[data-yume-lp-urgencia-reloj]');
        var fin = finEnMadrid(urgencia.getAttribute('data-fin'));
        var ocultarFin = urgencia.getAttribute('data-ocultar-fin') === 'true';
        var celdas = {};
        cada(urgencia.querySelectorAll('[data-yume-lp-u]'), function (celda) { celdas[celda.getAttribute('data-yume-lp-u')] = celda; });
        var dos = function (n) { return (n < 10 ? '0' : '') + n; };
        var intervalo = null;
        var pintarCelda = function (clave, valor) {
          var celda = celdas[clave];
          if (!celda || celda.textContent === valor) return;
          celda.textContent = valor;
          if (puedeAnimar) {
            celda.animate([
              { transform: 'translateY(-40%)', opacity: 0 },
              { transform: 'translateY(0)', opacity: 1 }
            ], { duration: 320, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
          }
        };
        var tic = function () {
          if (!fin || !reloj) {
            if (reloj) reloj.hidden = true;
            if (avisoModal) avisoModal.hidden = true;
            return;
          }
          var resto = Math.floor((fin.getTime() - Date.now()) / 1000);
          if (resto <= 0) {
            if (intervalo) window.clearInterval(intervalo);
            cada(urgencia.querySelectorAll('.yume-lp-urgencia__cifras'), function (cifras) { cifras.hidden = true; });
            var textoFin = urgencia.querySelector('[data-yume-lp-urgencia-fin]');
            if (textoFin) textoFin.hidden = false;
            if (ocultarFin || !textoFin) reloj.hidden = true;
            if (!urgencia.querySelector('.yume-lp-urgencia__stock') && reloj.hidden) urgencia.hidden = true;
            if (avisoModal) avisoModal.hidden = true;
            return;
          }
          var dias = Math.floor(resto / 86400);
          var horas = Math.floor((resto % 86400) / 3600);
          var minutos = Math.floor((resto % 3600) / 60);
          var segundos = resto % 60;
          pintarCelda('d', dos(dias));
          pintarCelda('h', dos(horas));
          pintarCelda('m', dos(minutos));
          pintarCelda('s', dos(segundos));
          urgencia.classList.toggle('yume-lp-urgencia--ultimas', resto < 86400);
          if (avisoModal) {
            var tiempoModal = (dias > 0 ? dias + 'd ' : '') + dos(horas) + ':' + dos(minutos) + ':' + dos(segundos);
            var hueco = avisoModal.querySelector('b');
            if (hueco) hueco.textContent = tiempoModal;
            avisoModal.hidden = false;
          }
        };
        tic();
        intervalo = window.setInterval(tic, 1000);
        var punto = urgencia.querySelector('.yume-lp-urgencia__punto');
        if (punto && puedeAnimar) {
          punto.animate([
            { scale: '1', opacity: 1 },
            { scale: '1.7', opacity: 0.35 },
            { scale: '1', opacity: 1 }
          ], { duration: 1200, iterations: Infinity, easing: 'ease-in-out' });
        }
        var relleno = urgencia.querySelector('.yume-lp-urgencia__barra-relleno');
        if (relleno && puedeAnimar && 'IntersectionObserver' in window) {
          var observadorStock = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (entrada) {
              if (!entrada.isIntersecting) return;
              observadorStock.disconnect();
              relleno.animate([
                { transform: 'scaleX(0)', transformOrigin: 'left center' },
                { transform: 'scaleX(1)', transformOrigin: 'left center' }
              ], { duration: 1200, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
            });
          }, { threshold: 0.6 });
          observadorStock.observe(relleno);
        }
      }

      iniciarUrgencia();

      actualizarOferta();
      iniciarCorte();
      animarOfertaContinua();
      animarBotonesCompra();

      function actualizarInversion(animarNoches) {
        var bloqueInv = raiz.querySelector('[data-yume-lp-inversion]');
        if (!bloqueInv) return;
        var rangoInv = bloqueInv.querySelector('[data-yume-lp-inv-rango]');
        var anos = rangoInv ? Number(rangoInv.value) || 1 : 1;
        var activoInv = packActivo();
        var unidadesInv = activoInv ? Number(activoInv.getAttribute('data-unidades')) || 1 : 1;
        var noches = anos * 365;
        var porNoche = estado.precio / unidadesInv / noches;
        var textoAnos = bloqueInv.querySelector('[data-yume-lp-inv-anos-texto]');
        if (textoAnos) textoAnos.textContent = anos + ' ' + (anos === 1 ? bloqueInv.getAttribute('data-texto-ano') : bloqueInv.getAttribute('data-texto-anos'));
        var cifra = bloqueInv.querySelector('[data-yume-lp-inv-noche]');
        if (cifra) cifra.textContent = formatearDinero(Math.max(1, Math.round(porNoche)), formato);
        var cajaNoches = bloqueInv.querySelector('[data-yume-lp-inv-noches]');
        if (cajaNoches) {
          var anterior = Number(cajaNoches.getAttribute('data-valor')) || 0;
          cajaNoches.setAttribute('data-valor', noches);
          if (animarNoches && anterior !== noches && !movimientoReducido) {
            var inicio = null;
            var paso = function (tiempo) {
              if (inicio === null) inicio = tiempo;
              var avance = Math.min((tiempo - inicio) / 700, 1);
              var suave = 1 - Math.pow(1 - avance, 3);
              cajaNoches.textContent = Math.round(anterior + (noches - anterior) * suave).toLocaleString('es-ES');
              if (avance < 1) window.requestAnimationFrame(paso);
            };
            window.requestAnimationFrame(paso);
          } else {
            cajaNoches.textContent = noches.toLocaleString('es-ES');
          }
        }
        cada(bloqueInv.querySelectorAll('.yume-lp-inversion__punto'), function (punto, indice) {
          punto.classList.toggle('yume-lp-encendido', indice < anos * 52);
        });
        var plantillaEq = bloqueInv.getAttribute('data-texto-equivale') || '';
        cada(bloqueInv.querySelectorAll('[data-yume-lp-inv-equivale]'), function (chip) {
          var precioTexto = String(chip.getAttribute('data-precio') || '').replace(/\./g, '').replace(',', '.');
          var precioComp = parseFloat(precioTexto) * 100;
          if (!precioComp || !porNoche) {
            chip.textContent = '';
            return;
          }
          var cuantas = Math.floor(precioComp / porNoche);
          chip.textContent = plantillaEq.replace('[[n]]', cuantas.toLocaleString('es-ES'));
        });
      }

      var bloqueInversion = raiz.querySelector('[data-yume-lp-inversion]');
      if (bloqueInversion) {
        var rangoInversion = bloqueInversion.querySelector('[data-yume-lp-inv-rango]');
        actualizarInversion(false);
        var cajaNochesInicio = bloqueInversion.querySelector('[data-yume-lp-inv-noches]');
        if (cajaNochesInicio) cajaNochesInicio.setAttribute('data-valor', '0');
        if (rangoInversion) {
          rangoInversion.addEventListener('input', function () {
            actualizarInversion(true);
            vibrar(8);
          });
        }
        if ('IntersectionObserver' in window && !modoEditor) {
          var observadorInv = new IntersectionObserver(function (entradas) {
            entradas.forEach(function (entrada) {
              if (!entrada.isIntersecting) return;
              observadorInv.disconnect();
              bloqueInversion.classList.add('yume-lp-inversion--activa');
              actualizarInversion(true);
            });
          }, { threshold: 0.3 });
          observadorInv.observe(bloqueInversion);
        } else {
          bloqueInversion.classList.add('yume-lp-inversion--activa');
          actualizarInversion(false);
        }
      }

      var comparadores = raiz.querySelectorAll('[data-yume-lp-cuello]');
      cada(comparadores, function (comparador) {
        var rango = comparador.querySelector('[data-yume-lp-cuello-rango]');
        if (!rango) return;
        var aplicarCorte = function (valor) {
          comparador.style.setProperty('--yume-lp-corte', valor + '%');
        };
        var tocado = false;
        rango.addEventListener('input', function () {
          tocado = true;
          aplicarCorte(rango.value);
        });
        aplicarCorte(rango.value);
        if (movimientoReducido || modoEditor || !('IntersectionObserver' in window)) return;
        var observadorCuello = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (!entrada.isIntersecting) return;
            observadorCuello.disconnect();
            var inicio = null;
            var duracion = 2200;
            var paso = function (tiempo) {
              if (tocado) return;
              if (inicio === null) inicio = tiempo;
              var progreso = Math.min((tiempo - inicio) / duracion, 1);
              var valor = 50 + Math.sin(progreso * Math.PI * 2) * 22 * (1 - progreso);
              rango.value = Math.round(valor);
              aplicarCorte(valor.toFixed(2));
              if (progreso < 1) window.requestAnimationFrame(paso);
            };
            window.setTimeout(function () { window.requestAnimationFrame(paso); }, 400);
          });
        }, { threshold: 0.5 });
        observadorCuello.observe(comparador);
      });

      var tarjetasVideo = raiz.querySelectorAll('[data-yume-lp-video]');
      var videosLanding = [];
      cada(tarjetasVideo, function (tarjeta) {
        var video = tarjeta.querySelector('video');
        if (!video) return;
        video.muted = true;
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        video.removeAttribute('controls');
        videosLanding.push(video);
        var botonSonido = tarjeta.querySelector('[data-yume-lp-sonido]');
        if (botonSonido) {
          botonSonido.addEventListener('click', function () {
            var activar = video.muted;
            videosLanding.forEach(function (otro) {
              otro.muted = true;
              var otroBoton = otro.closest('[data-yume-lp-video]').querySelector('[data-yume-lp-sonido]');
              if (otroBoton) otroBoton.setAttribute('aria-pressed', 'false');
            });
            video.muted = !activar;
            botonSonido.setAttribute('aria-pressed', activar ? 'true' : 'false');
            if (activar) {
              var intento = video.play();
              if (intento && intento.catch) intento.catch(function () {});
            }
          });
        }
      });
      if (videosLanding.length && 'IntersectionObserver' in window) {
        var observadorVideo = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            var video = entrada.target;
            if (entrada.isIntersecting && !movimientoReducido) {
              var intento = video.play();
              if (intento && intento.catch) intento.catch(function () {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.25 });
        videosLanding.forEach(function (video) {
          video.pause();
          observadorVideo.observe(video);
        });
      }

      var capas = raiz.querySelector('[data-yume-lp-capas]');
      var revelar = raiz.querySelectorAll('.yume-lp-revelar');
      var animar = raiz.getAttribute('data-animar') === 'true' && !movimientoReducido && !modoEditor;
      if ('IntersectionObserver' in window) {
        if (animar) raiz.classList.add('yume-lp-animado');
        var observador = new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.isIntersecting) {
              entrada.target.classList.add('yume-lp-visible');
              observador.unobserve(entrada.target);
            }
          });
        }, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 });
        if (animar) cada(revelar, function (elemento) { observador.observe(elemento); });
        if (capas) observador.observe(capas);
      } else if (capas) {
        capas.classList.add('yume-lp-visible');
      }

      if (barra && boton && 'IntersectionObserver' in window) {
        var fueraBoton = false;
        var finalVisible = false;
        var final = raiz.querySelector('.yume-lp-final');
        var aplicarBarra = function () {
          var mostrar = fueraBoton && !finalVisible;
          barra.classList.toggle('yume-lp-barra--visible', mostrar);
          barra.setAttribute('aria-hidden', mostrar ? 'false' : 'true');
          if (botonBarra) botonBarra.setAttribute('tabindex', mostrar ? '0' : '-1');
          var enlaceBarra = barra.querySelector('[data-yume-lp-barra-enlace]');
          if (enlaceBarra) enlaceBarra.setAttribute('tabindex', mostrar ? '0' : '-1');
        };
        new IntersectionObserver(function (entradas) {
          entradas.forEach(function (entrada) {
            if (entrada.target === boton) fueraBoton = !entrada.isIntersecting && entrada.boundingClientRect.top < 0;
            if (entrada.target === final) finalVisible = entrada.isIntersecting;
          });
          aplicarBarra();
        }).observe(boton);
        if (final) {
          new IntersectionObserver(function (entradas) {
            finalVisible = entradas[0].isIntersecting;
            aplicarBarra();
          }).observe(final);
        }
        var drawer = document.querySelector('cart-drawer');
        if (drawer && 'MutationObserver' in window) {
          new MutationObserver(function () {
            if (drawer.classList.contains('active')) barra.classList.remove('yume-lp-barra--visible');
            else aplicarBarra();
          }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
        }
      }

      pintar();
    }

    function iniciarTodas(contenedor) {
      cada(contenedor.querySelectorAll('[data-yume-lp]'), iniciar);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { iniciarTodas(document); });
    } else {
      iniciarTodas(document);
    }

    document.addEventListener('shopify:section:load', function (evento) {
      iniciarTodas(evento.target);
    });

    document.addEventListener('shopify:block:select', function (evento) {
      var detalle = evento.target && evento.target.closest ? evento.target.closest('details') : null;
      if (detalle) detalle.open = true;
    });
  })();
